var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_357_1888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.71652 0 0 6.71652 0 15C0 23.2835 6.71652 30 15 30C23.2835 30 30 23.2835 30 15C30 6.71652 23.2835 0 15 0ZM22.2087 11.3069C22.2187 11.4643 22.2187 11.6283 22.2187 11.7891C22.2187 16.7042 18.4754 22.3661 11.635 22.3661C9.52567 22.3661 7.57031 21.7533 5.92299 20.6987C6.22433 20.7321 6.51228 20.7455 6.82031 20.7455C8.56138 20.7455 10.1618 20.1562 11.4375 19.1585C9.80357 19.125 8.4308 18.0536 7.96205 16.5804C8.5346 16.6641 9.05022 16.6641 9.63951 16.5134C8.79819 16.3425 8.04199 15.8855 7.49938 15.2203C6.95678 14.555 6.66123 13.7223 6.66295 12.8638V12.817C7.15513 13.0949 7.73438 13.2656 8.3404 13.2891C7.83095 12.9495 7.41314 12.4895 7.12403 11.9499C6.83493 11.4102 6.68345 10.8075 6.68304 10.1953C6.68304 9.50223 6.86384 8.86942 7.18862 8.32031C8.12244 9.46988 9.28771 10.4101 10.6087 11.0798C11.9297 11.7495 13.3768 12.1338 14.856 12.2076C14.3304 9.67969 16.2188 7.63393 18.4888 7.63393C19.5603 7.63393 20.5246 8.08259 21.2042 8.8058C22.0446 8.64844 22.8482 8.3337 23.5647 7.91183C23.2868 8.77232 22.7042 9.49888 21.9308 9.95759C22.6808 9.87723 23.404 9.66964 24.0737 9.37835C23.5681 10.1217 22.9353 10.7812 22.2087 11.3069Z",
    fill: "#0086EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_357_1888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorTwitter);
export default __webpack_public_path__ + "static/media/color_twitter.99ddbab7a8dd7cc25dbb92ebbf99e6cf.svg";
export { ForwardRef as ReactComponent };